/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { useState, useCallback, useEffect } from 'react';

export default function useApi({ isImmediate = false, fetcher, params: parameters = {} }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const request = useCallback(
    async (overrideParameters = {}) => {
      setLoading(true);
      setError(null);

      const mergedParameters = { ...parameters, ...overrideParameters };

      try {
        const response = await fetcher(mergedParameters);
        setData(response);
        return response;
      } catch (error_) {
        setError(error_);
        setData(null);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [fetcher],
  );

  useEffect(() => {
    if (isImmediate) {
      request();
    }

    return () => {
      setData(null);
      setError(null);
      setLoading(false);
    };
  }, [isImmediate]);

  return { data, error, loading, request };
}
